import { Component, OnInit } from '@angular/core';
import { InstitutionsService } from '../../shared/services/institutions.service';
import { FormGroup } from '@angular/forms';
import { Institution, IUsers, UserRights, IClose } from '../../shared/model/institution';
import { SaveService } from '../../shared/services/save.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-institution-update',
  templateUrl: './institution-update.component.html',
  styleUrls: ['./institution-update.component.css']
})
export class InstitutionUpdateComponent implements OnInit {

  constructor(private institutionsService: InstitutionsService,
    private saveService: SaveService, private router: Router) { }

  form: FormGroup;
  institution: Institution;

  ngOnInit() {
    this.institution = this.saveService.getInstitution();
    this.saveService.setTitle(`Modifier ${this.institution.institutionName}`);
  }

  onOutForm(form: FormGroup) {
    this.form = form;
  }

  onSubmit = (form) => {
    console.log(form.valid)
    if (form.valid) {
      this.save(form);
    }
  }

  onCancel = () => {
    this.saveService.setTitle("Gestion des institutions");
    this.router.navigate(['institution-list']);
  }

  formatInstitution(value): Institution {
    console.log('=======================value = ', value)
    const currentUser = this.saveService.getUser();
    const users: IUsers[] = [{ 
      user: currentUser.email, 
      rights: UserRights[UserRights.ADMIN],
      userId: currentUser.$key 
    }];
    const close: IClose[] = [{
      type: 'student',
      ind: true
    }]
    return new Institution("",
      this.institution.$key,
      value.institutionName,
      value.institutionAddress,
      value.institutionCity,
      value.institutionProv,
      value.institutionPostalCode,
      value.institutionCountry,
      value.institutionPhone,
      value.institutionPhoneExt,
      value.institutionEmail,
      value.institutionRespOrgId,   /*****TO BE DETERMINER ID******** */
      value.institutionRespOrgName,
      value.institutionAdmRegion,
      value.institutionType,
      value.contactLastName,
      value.contactFirstName,
      value.contactTitle,
      value.contactPhone,
      value.contactPhoneExt,
      value.contactEmail,
      value.student,
      value.guardDuty,
      value.buses,
      value.teacher,
      value.smsNotification,
      value.emailNotification,
      value.phoneNotification,
      value.powerUserTransfert,
      value.preSchool,
      value.primarySchool,
      value.secondarySchool,
      value.adultSchool,
      value.professionnelSchool,
      value.collegeSchool,
      value.universitySchool,
      value.languageFrench,
      value.languageEnglish,
      users,
      close
    )
  }
  
  save(form) {
    console.log('this.institution.$key              =',this.institution.$key)
    console.log('this.formatInstitution(form.value) =',this.formatInstitution(form.value))
    this.institutionsService.saveInstitution(this.institution.$key, this.formatInstitution(form.value))
      .subscribe(
      () => {
        form.reset();
        this.router.navigate(['choice-responsible'])
      },
      err => console.error(`error creating institution ${this.institution.$key} error = ${err}`)
      );

  }
}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/institutions/institution-update/institution-update.component.ts